module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Log Out":"Log Out","user":"user","UserId copied successfully":"UserId copied successfully"},"zh":{"Log Out":"退出登录","user":"用户","UserId copied successfully":"用户ID复制成功"}}')
  delete Component.options._Ctor
}
